type AuthActions = {
  refreshAuth: () => Promise<void>;
  logout: () => Promise<void>;
};

type LoaderActions = {
  showLoader: () => void;
  hideLoader: () => void;
};

export const checkAuthentication = async (
  isChecked: boolean,
  { refreshAuth, logout }: AuthActions,
  { showLoader, hideLoader }: LoaderActions
): Promise<boolean> => {
  if (isChecked) return true;

  showLoader();
  try {
    await refreshAuth();
    return true;
  } catch (error) {
    await logout();
    return false;
  } finally {
    hideLoader();
  }
};
